import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { KycConfirmAccountRoutingModule } from './kyc-confirm-account-routing.module';
import { TranslateModule } from '@ngx-translate/core';
import { MaterialModule } from 'src/app/core/material';
import { SharedModule } from 'src/app/shared/shared.module';
import {NgxExtendedPdfViewerModule} from 'ngx-extended-pdf-viewer';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import {WebcamModule} from 'ngx-webcam';
import {KycConfirmAccountReviewComponent} from './kyc-confirm-account.component';
import { AlertEkycComponent } from 'src/app/shared/components/alert-ekyc/alert-ekyc.component';
import { UpdateAsEnterpriseReviewComponent } from './update-as-enterprise-review/update-as-enterprise.component';

@NgModule({
  declarations: [KycConfirmAccountReviewComponent,UpdateAsEnterpriseReviewComponent],
  imports: [
    CommonModule,
      KycConfirmAccountRoutingModule,
      TranslateModule,
      MaterialModule,
      SharedModule,
      NgxExtendedPdfViewerModule,
      FormsModule,
      ReactiveFormsModule,
      WebcamModule
  ],
  entryComponents: [
    AlertEkycComponent,
    UpdateAsEnterpriseReviewComponent,
  ],
})
export class KycConfirmAccountModuleReview { }
